const ISO_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

const normalizeIsoDate = (value) => {
    const normalized = typeof value === "string" ? value.trim() : "";
    return ISO_DATE_PATTERN.test(normalized) ? normalized : "";
};

export const normalizeDateInput = (value) => {
    if (value === null || value === undefined || value === "") {
        return null;
    }
    if (value instanceof Date) {
        return Number.isNaN(value.getTime()) ? null : new Date(value.getTime());
    }
    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
};

const pad2 = (value) => String(value).padStart(2, "0");

export const toLocalDateIso = (value) => {
    const parsed = normalizeDateInput(value);
    if (!parsed) {
        return "";
    }
    return `${parsed.getFullYear()}-${pad2(parsed.getMonth() + 1)}-${pad2(parsed.getDate())}`;
};

export const isTodayIsoDate = (isoDate, now = new Date()) => {
    const normalizedIso = normalizeIsoDate(isoDate);
    if (!normalizedIso) {
        return false;
    }
    const todayIso = toLocalDateIso(now);
    return normalizedIso === todayIso;
};

const deriveIsoFromLabel = (label) => {
    const normalizedLabel = typeof label === "string" ? label.trim() : "";
    if (!normalizedLabel) {
        return "";
    }
    const directIso = normalizeIsoDate(normalizedLabel);
    if (directIso) {
        return directIso;
    }
    return toLocalDateIso(normalizedLabel);
};

export const getDateSeparatorMetadata = (dateInput, formatDate) => {
    const parsed = normalizeDateInput(dateInput);

    if (!parsed) {
        const fallbackLabel = typeof dateInput === "string" ? dateInput.trim() : "";
        return {
            isoDate: deriveIsoFromLabel(fallbackLabel),
            label: fallbackLabel,
            displayLabel: fallbackLabel,
        };
    }

    const isoDate = toLocalDateIso(parsed);
    const formattedLabel = typeof formatDate === "function" ? String(formatDate(parsed) || "").trim() : "";
    const label = formattedLabel || parsed.toLocaleDateString();
    const displayLabel = isTodayIsoDate(isoDate) ? "Today" : label;

    return {
        isoDate,
        label,
        displayLabel,
    };
};

export const readDateSeparatorMetadata = (element) => {
    if (!element || typeof element.getAttribute !== "function") {
        return { isoDate: "", label: "" };
    }

    const rawIsoDate = element.getAttribute("data-date-iso");
    const rawLabel = element.getAttribute("data-date-label") || element.getAttribute("data-date") || "";
    const label = typeof rawLabel === "string" ? rawLabel.trim() : "";
    const isoDate = normalizeIsoDate(rawIsoDate) || deriveIsoFromLabel(label);

    return { isoDate, label };
};

export const resolveStickyDateLabel = ({ isoDate, label } = {}) => {
    if (isTodayIsoDate(isoDate)) {
        return "Today";
    }
    const normalizedLabel = typeof label === "string" ? label.trim() : "";
    return normalizedLabel || normalizeIsoDate(isoDate) || "";
};
